/**
 * Langues du nom de service, dans l'ORDRE configuré et filtrées par visibilité.
 * @author Dr Hamid MADANI <drmdh@msn.com>
 *
 * Piloté depuis la console (Styles → styles.display) : par langue, un rang d'ORDRE
 * (`serviceNameOrder{Ar,En,Fr}`), une visibilité (`showServiceName…`) et une échelle de
 * taille (`serviceNameScale…`, appliquée en CSS). Défaut : AR(1) → EN(2) → FR(3).
 *
 * `prefix` = base des classes CSS ('service-name' pour la carte de comptage,
 * 'service-grid-name' pour la grille) ; FR utilise la base, AR/EN le suffixe `-ar`/`-en`.
 */
export function orderedServiceLangs(dispCfg = {}, prefix) {
  const langs = [
    { key: 'ar', order: Number(dispCfg.serviceNameOrderAr ?? 1), show: dispCfg.showServiceNameAr !== false, cls: `${prefix}-ar rtl`, dir: 'rtl', text: (s) => s.nameAr },
    { key: 'en', order: Number(dispCfg.serviceNameOrderEn ?? 2), show: dispCfg.showServiceNameEn !== false, cls: `${prefix}-en`, dir: undefined, text: (s) => s.nameEn },
    { key: 'fr', order: Number(dispCfg.serviceNameOrderFr ?? 3), show: dispCfg.showServiceNameFr !== false, cls: prefix, dir: undefined, text: (s) => s.name },
  ];
  return langs.filter((l) => l.show).sort((a, b) => a.order - b.order);
}
